<template>
	<div class="search-date-profit">
		<div class="el-search vue-top-padding radius">
			<el-row :gutter="20">
				<el-col :span="3">
					<div class="el-left">
						<el-button
							size="small"
							icon="el-icon-printer"
							@click="exportOrder"
							>{{ $t("common.export") }}</el-button
						>
					</div>
				</el-col>
				<el-col :span="21">
					<div class="el-right">
						<el-form
							ref="order"
							:model="search"
							:inline="true"
							label-width="10px"
							size="small"
							class="demo-form-inline el-input-height"
						>
							<el-form-item>
								<el-date-picker
									v-model="dateTime"
									type="daterange"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									range-separator="-"
									:start-placeholder="$t('searchDateProfit.start')"
									:end-placeholder="$t('searchDateProfit.end')"
								>
								</el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button
									type="primary"
									@click="onSubmit"
									icon="el-icon-search"
									>{{ $t("common.search") }}</el-button
								>
								<el-button
									@click="resetSearch('order')"
									icon="el-icon-refresh"
									>{{ $t("common.reset") }}</el-button
								>
							</el-form-item>
						</el-form>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchDateProfit",
	props: {
		search: Object,
	},
	data() {
		return {
			dateTime: "",
		};
	},
	methods: {
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.search.startTime = this.dateTime[0];
				this.search.endTime = this.dateTime[1];
			}
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields(); // 这个只是清除了表单数据，对象并没有重新赋值，所以调用下面的方法赋空值
			this.$toolUtil.clearForm(this.search);
			this.dateTime = "";
			this.$emit("resetSearch", this.search);
		},
		exportOrder() {
			this.$confirm(this.$t("searchDateProfit.export"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			})
				.then(() => {
					this.$notify({
						title: this.$t("common.tip"),
						icon: "warning",
						message: this.$t("common.exportloading"),
						position: "bottom-right",
						type: "warning",
					});
					this.$api.download(this.$url.Statistics.exportDate, this.search);
				})
				.catch(err => {
					this.$message.error(err.msg);
				});
		},
	},
};
</script>

<style scoped></style>
